<template>
  <div>
    <BCollapse
      v-if="
        localeInitialized &&
          localeReferences && ((localeReferences.withoutScope &&
            Object.keys(localeReferences.withoutScope).length !== 0) ||
            (localeReferences.withScope && Object.keys(localeReferences.withScope).length !== 0))
      "
      :model-value="openReference"
      animation="slide"
      aria-id="collapseReferenceSection"
      class="collapseCard"
    >
      <template #trigger="detailReference">
        <div
          :aria-expanded="!detailReference.open"
          aria-controls="collapseReferenceSection"
          class="card-header thickDouble"
        >
          <p
            class="card-header-title"
            :aria-label="$t('applications.references')"
          >
            {{ $t("applications.references") }}
          </p>
          <a
            :tabindex="
              localeInitialized &&
                ((localeReferences.withoutScope &&
                  Object.keys(localeReferences.withoutScope).length !== 0) ||
                  (localeReferences.withScope &&
                    Object.keys(localeReferences.withScope).length !== 0))
                ? 0
                : -1
            "
            class="card-header-icon"
            @keyup.enter="openReference = !openReference"
            @keyup.space="openReference = !openReference"
          >
            <BIcon
              :icon="detailReference.open ? 'chevron-up' : 'chevron-down'"
              type="is-primary"
            />
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <AuthorizationsForNoAuthorization
            v-if="
              localeInitialized &&
                localeReferences.withoutScope &&
                Object.keys(localeReferences.withoutScope).length !== 0
            "
            class="tableDetails"
            :application="localeApplication"
            :authorization="
              localeCurrentAuthorization.authorizations
                ? localeCurrentAuthorization.authorizations
                : localeAuthorizations
            "
            :data-types="localeReferences.withoutScope"
            :has-dependencies="localeHasDependencies"
            :list-column-scope="localeListColumnName['withoutScope']"
            @update:authorization="$emit('update:authorization', $event)"
          />
          <AuthorizationForScope
            v-if="
              localeInitialized &&
                localeReferences.withScope &&
                Object.keys(localeReferences.withScope).length !== 0
            "
            :application="localeApplication"
            :authorization="
              localeCurrentAuthorization.authorizations
                ? localeCurrentAuthorization.authorizations
                : localeAuthorizations
            "
            :authorizations-description="localeAuthorizations"
            :data-types="datatypes.withScope"
            :has-dependencies="localeHasDependencies"
            :list-column-scope="localeListColumnName['withScope']"
            :references-scopes="localeReferencesScopes"
            @update:authorization="$emit('update:authorization', $event)"
          />
        </div>
      </div>
    </BCollapse>
    <BCollapse
      v-if="
        localeInitialized &&
          ((localeDatatypes.withoutScope && Object.keys(localeDatatypes.withoutScope).length !== 0) ||
            (localeDatatypes.withScope && Object.keys(localeDatatypes.withScope).length !== 0))
      "
      :model-value="openDatatype"
      animation="slide"
      aria-id="collapseDatatypeSection"
      class="collapseCard"
    >
      <template #trigger="detailDatatype">
        <div
          :aria-expanded="!detailDatatype.open"
          aria-controls="collapseDatatypeSection"
          class="card-header thickDouble"
        >
          <p
            class="card-header-title"
            :aria-label="$t(titleCollapse)"
          >
            {{ $t(titleCollapse) }}
          </p>
          <a
            :tabindex="
              localeInitialized &&
                ((localeDatatypes.withoutScope &&
                  Object.keys(localeDatatypes.withoutScope).length !== 0) ||
                  (localeDatatypes.withScope && Object.keys(localeDatatypes.withScope).length !== 0))
                ? 0
                : -1
            "
            class="card-header-icon"
            @keyup.enter="openDatatype = !openDatatype"
            @keyup.space="openDatatype = !openDatatype"
          >
            <b-icon
              :icon="detailDatatype.open ? 'chevron-up' : 'chevron-down'"
              type="is-primary"
            />
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <AuthorizationsForNoAuthorization
            v-if="
              localeInitialized &&
                localeDatatypes.withoutScope &&
                Object.keys(localeDatatypes.withoutScope).length !== 0
            "
            class="tableDetails"
            :application="localeApplication"
            :authorization="
              localeCurrentAuthorization.authorizations
                ? localeCurrentAuthorization.authorizations
                : localeAuthorizations
            "
            :data-types="localeDatatypes.withoutScope"
            :has-dependencies="localeHasDependencies"
            :list-column-scope="localeListColumnName['withoutScope']"
            @update:authorization="$emit('update:authorization', $event)"
          />
          <AuthorizationForScope
            v-if="
              localeInitialized &&
                localeDatatypes.withScope &&
                Object.keys(localeDatatypes.withScope).length !== 0
            "
            :application="localeApplication"
            :authorization="
              localeCurrentAuthorization.authorizations
                ? localeCurrentAuthorization.authorizations
                : localeAuthorizations
            "
            :authorizations-description="localeAuthorizations"
            :data-types="localeDatatypes.withScope"
            :has-dependencies="localeHasDependencies"
            :list-column-scope="localeListColumnName['withScope']"
            :references-scopes="localeReferencesScopes"
            @update:authorization="$emit('update:authorization', $event)"
          />
        </div>
      </div>
    </BCollapse>
  </div>
</template>

<script lang="ts">
import AuthorizationsForNoAuthorization from "@/components/common/authorization/AuthorizationsForNoAuthorization.vue";
import AuthorizationForScope from "@/components/common/authorization/AuthorizationForScope.vue";
import { computed, watch } from "vue";
import useBoolean from "@/composable/components/boolean";
import { BCollapse, BIcon } from "buefy";
import { getListColumnName } from "@/composable/authorization/grantableInfos";
import "@/style/components/AuthorizationTableForDatatype.scss";

export default {
  name: "AuthorizationTableForDatatype",
  components: {
    BIcon,
    BCollapse,
    AuthorizationsForNoAuthorization,
    AuthorizationForScope,
  },
  props: {
    applicationName: String,
    authorizationId: {
      type: String,
      default: "new",
    },
    titleCollapse: {
      type: String,
      default: "applications.dataset",
      required: false,
    },
    datatypes: {
      type: Object,
      required: true,
    },
    hasDependencies: {
      type: Array,
      default: () => [],
    },
    initialized: Boolean,
    references: {
      type: Object,
      required: false,
    },
    application: {
      type: Object,
      required: true,
    },
    currentAuthorization: {
      type: Object,
      required: true,
    },
    authorizations: {
      type: Object,
    },
    referencesScopes: {
      type: Object,
    },
    hasPublicAuthorizations: {
      type: Boolean,
      default: false,
    },
    isDataCollapseOpen: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ["update:authorization"],
  setup(props) {
    const localeApplicationName = computed(() => props.applicationName || "");
    const localeAuthorizationId = computed(() => props.authorizationId);
    const localeDatatypes = computed(() => props.datatypes || {});
    const localeListColumnName = getListColumnName();
    const localeHasDependencies = computed(() => props.hasDependencies);
    const localeInitialized = computed(() => props.initialized || false);
    const localeReferences = computed(() => props.references);
    const localeApplication = computed(() => props.application);
    const localeCurrentAuthorization = computed(() => props.currentAuthorization);
    const localeAuthorizations = computed(() => props.authorizations || {});
    const localeReferencesScopes = computed(() => props.referencesScopes || {});
    const { refBoolean: openReference } = useBoolean(false);
    const { refBoolean: openDatatype } = useBoolean(props.isDataCollapseOpen);

    watch(
      () => props.hasPublicAuthorizations,
      (newVal) => {
        if (newVal) {
          delete localeListColumnName.value["withoutScope"]?.delete;
          delete localeListColumnName.value["withScope"]?.delete;
          delete localeListColumnName.value["withoutScope"]?.depot;
          delete localeListColumnName.value["withScope"]?.depot;
          delete localeListColumnName.value["withScope"]?.publication;
        }
      },
    );

    return {
      localeApplicationName,
      localeAuthorizationId,
      localeDatatypes,
      localeListColumnName,
      localeHasDependencies,
      localeInitialized,
      localeReferences,
      localeApplication,
      localeCurrentAuthorization,
      localeAuthorizations,
      localeReferencesScopes,
      openDatatype,
      openReference,
    };
  },
};
</script>
